import {gsap} from 'gsap';

( function( app ) {
  const COMPONENT = {
    instances: [],
    maximumScreenWidth: null,
    init: function() {},
    construct: function() {
      this.maximumScreenWidth = window.screen.width;
      this.instances = gsap.utils.toArray( '.js-has-marquee[data-component]' );
      this.instances?.map( ( $componentEl ) => {
        if ( $componentEl._marqueeElement ) return $componentEl;

        $componentEl._marqueeElement = $componentEl.querySelector( '.js-marquee' );
        if ( $componentEl._marqueeElement ) {
          const template = $componentEl._marqueeElement.querySelector( 'template' );
          $componentEl._marqueeElement._items = JSON.parse( $componentEl._marqueeElement.dataset.items )?.map( ( text ) => () => {
            const itemTemplate = template.cloneNode( true );
            itemTemplate.innerHTML = `${itemTemplate.innerHTML.replace( /\$\{text}/g, text )}`;
            return itemTemplate.content?.cloneNode( true );
          } );
        }

        return $componentEl;
      } );

      this.createLoopedItems();
      this.animate();
    },
    resize: function() {
      if ( this.maximumScreenWidth !== window.screen.width ) {
        this._instances = [];
        this.construct();
      }
    },
    animate: function() {
      this.instances.forEach( ( $componentEl ) => {
        if ( $componentEl._marqueeElement ) {
          if ( $componentEl._marqueeElement?._tween ) {
            $componentEl._marqueeElement?._tween.scrollTrigger.refresh();
          } else {
            $componentEl._marqueeElement._tween = gsap.to( $componentEl._marqueeElement, {
              x: () => '-100vw',
              scrollTrigger: {
                trigger: $componentEl,
                scrub: true,
                start: 'top bottom',
                end: 'bottom top',
              },
            } );
          }
        }
      } );
    },
    createLoopedItems: function() {
      this.instances.forEach( ( $componentEl ) => {
        if ( !$componentEl._marqueeElement || $componentEl._marqueeElement?._items?.length === 0 ) return;

        $componentEl._marqueeElement.innerHTML = '';
        let marqueeWidth = $componentEl._marqueeElement.offsetWidth;
        while ( marqueeWidth < ( this.maximumScreenWidth * 2 ) ) {
          $componentEl._marqueeElement._items.forEach( ( createEl ) => {
            $componentEl._marqueeElement.appendChild( createEl() );
          } );

          marqueeWidth = $componentEl._marqueeElement.offsetWidth;
        }
      } );
    },
    finalize: function() {
      this.construct();
      window.addEventListener( 'resize', () => this.resize() );
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-banner', COMPONENT );
} )( app );
